import './opportunity-log.component.scss';
import {IPromise} from "angular";
import {Pageable} from "../../../utils/models/Page";
import {Customer} from "../../../customers/model/Customer";

export class OpportunityLogComponent {

    static instance = {
        template: require('./opportunity-log.component.html'),
        controller: [
            OpportunityLogComponent
        ],
        bindings: {
            customer: '<',
            logs: '<',
            pagingConfig: '<',
            fetchLogs: '<'
        }
    };

    private customer: Customer;
    private logs: any[];
    private pagingConfig: Pageable;
    private fetchCustomerLogs: () => IPromise<void>;


}